
      var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 69.545V15a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v90a5 5 0 0 1-5 5h-35m20-85h-20",
  stroke: "#fff",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.529 90.167c4.567-11.116-.418-17.92-8.23-21.435-2.738 10.909-5.804 23.758-7.867 30.845-1.63 5.594-7.699 8.868-13.847 7.231-6.148-1.637-9.915-7.529-8.416-13.16 1.5-5.63 7.699-8.868 13.846-7.231 3.37.897 5.307 3.165 6.024 4.808 3.58-14.045 7.423-29.273 9.392-37.068.739-2.923 1.769-3.418 2.862-3.127 1.71.455 1.208 2.567 1.487 3.686.67 3.142 3.41 4.126 6.004 6.12 4.193 3.223 6.598 9.143 6.143 15.128-.42 5.536-3.273 10.957-7.398 14.203Z",
  fill: "url(#success_b2fcd4730fcf75e2__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "success_b2fcd4730fcf75e2__a",
  x1: 53.219,
  y1: 51.01,
  x2: 37.781,
  y2: 108.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.508,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M30.5 69.5452V15C30.5 12.2386 32.7386 10 35.5 10H85.5C88.2614 10 90.5 12.2386 90.5 15V105C90.5 107.761 88.2614 110 85.5 110H50.5M70.5 25H50.5\" stroke=\"white\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M59.5289 90.1671C64.0963 79.0507 59.1112 72.2468 51.2993 68.7317C48.561 79.6406 45.4947 92.4904 43.4316 99.5766C41.8024 105.171 35.7331 108.445 29.5853 106.808C23.4375 105.171 19.6697 99.279 21.1691 93.6481C22.6684 88.0172 28.8676 84.7798 35.0154 86.4167C38.3844 87.3138 40.3219 89.5819 41.0386 91.2255C44.6192 77.1802 48.4621 61.9519 50.4312 54.1568C51.1699 51.2341 52.1996 50.7389 53.2934 51.0301C55.003 51.4854 54.5012 53.5968 54.7797 54.7163C55.4494 57.8584 58.1897 58.8416 60.784 60.8353C64.9773 64.059 67.3816 69.9794 66.927 75.9639C66.5072 81.5002 63.6543 86.9205 59.5291 90.1666L59.5289 90.1671Z\" fill=\"url(#paint0_linear_9195_5492)\"/>\r\n<defs>\r\n<linearGradient id=\"paint0_linear_9195_5492\" x1=\"53.2192\" y1=\"51.0104\" x2=\"37.7808\" y2=\"108.99\" gradientUnits=\"userSpaceOnUse\">\r\n<stop offset=\"0.508104\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n<stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n</linearGradient>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/success.b2fcd4730fcf75e22de3fe2349a2def2.svg"),
        {
          React: SvgSuccess,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      